<div class="common-dropdown-container"
  [id]="'participants-list-'+participantsList.id">
  <span-tooltip class="common-table-cell__standard-text-label"
    [text]="participantsList.name"
    [isDeleted]="participantsList.participants[0]?.isDeleted"></span-tooltip>
  @if (participantsList.participants?.length > 1) {
    <div class="common-badge__badge-block">
      <button class="common-badge__square-color-blue"
        (click)="toggleMenu($event)">
        @if(previousAction){
          <span>{{participantsList.participants?.length}}</span>
        }@else{
          <span>+</span>
          <span>{{participantsList.participantsCount}}</span>
        }
      </button>
      <list-in-dropdown
        [list]="participantsList.participants"
        [patternId]="'participants-list-'+participantsList.id"
        [type]="type"></list-in-dropdown>
    </div>
  }
</div>
